import * as yup from 'yup'

export const contactUsSchema = yup.object().shape(
  {
    name: yup.string().required('Campo obrigatório'),
    company: yup.string().notRequired(),
    email: yup
      .string()
      .email('E-mail inválido')
      .required('Campo obrigatório'),
    phone: yup
      .string()
      .required('Campo obrigatório'),
    message: yup.string().required('Campo obrigatório'),
  },
)
